import axios from "../../../axiosClient";

export const getRainProfile = async (
  pageSize: any,
  PageNumber: any,
  SortBy: any,
  SortDirection: any,
  id: any,
  searchText: any = ""
) => {
  const body = {
    pageSize,
    PageNumber,
    SortBy,
    SortDirection,
    searchText,
  };
  const res = await axios.get(`/slpapp/RainProfile/GetRainProfile`, {
    params: { assetCode: id, ...body },
  });

  return res?.data?.data;
};
